<template lang="html">
  <section class="uploadInfoBox">
    <el-dialog  fullscreen lock-scroll center :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" title="" :visible.sync="visible" width="">
      <div class="uploadInfo">
        <div class="uploadInfo_icon">
          <i class="el-icon-loading"></i>
        </div>
        <div class="uploadInfo_percent">
          文件已上传{{parseInt((uploadInfo.percent?uploadInfo.percent:0)*100)}}%,上传速度{{((uploadInfo.speed?uploadInfo.speed:0)/1024/1024).toFixed(2)}}M/s,请不要关闭或离开此页面
        </div>
      </div>

    </el-dialog>
  </section>
</template>
<script>
export default {
  name: "dialogUploadInfo",
  props:{
  },
  data(){
    return{
      visible:false,
      uploadInfo:{}
    }
  },
  mounted() {},
  updated(){
    // console.log('更新',this);
  },
}
</script>

<style lang="css" scoped>

.uploadInfoBox {}

.uploadInfoBox /deep/ .el-dialog {
  background-color: rgba(0, 0, 0, 0.3);
  text-align: center;
}

.uploadInfoBox  /deep/ .uploadInfo {
  color: #409eff;
  text-align: center;
  padding-top: 25vh;
}

.uploadInfoBox /deep/ .uploadInfo div {
  font-size: 16px;
  line-height: 30px;
}

.uploadInfoBox /deep/ .uploadInfo div i {
  color: #409eff;
  font-size: 20px;
}


</style>
